/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { CmsPageRequest, CmsPageResponse } from "state/cms-page";

import { CMS_PAGE_REQUEST, CMS_PAGE_RESPONSE } from "state/cms-page";
import { cmsPage } from "queries";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: CmsPageRequest) => {
      const { page } = await client(cmsPage, {
        url: msg.url,
      }, { cache: true });

      return ({
        tag: CMS_PAGE_RESPONSE,
        data: page,
      }: CmsPageResponse);
    },
    subscribe: { [CMS_PAGE_REQUEST]: true },
  });
};

export default registerClient;
